import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceCards from './components/ServiceCards';
import FeaturedWorks from './components/FeaturedWorks';
import PricingSection from './components/PricingSection';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { homeSEO, siteInfo } from '@/mocks/photography';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: window.location.origin + (window.__BASE_PATH__ || ''),
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${window.location.origin}${window.__BASE_PATH__ || ''}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: window.location.origin + (window.__BASE_PATH__ || ''),
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '建国路88号SOHO现代城A座1208室',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: homeSEO.title,
  description: homeSEO.description,
  url: window.location.origin + (window.__BASE_PATH__ || '') + '/',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <SEOHead data={homeSEO} />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceCards />
        <FeaturedWorks />
        <PricingSection />
        <Testimonials />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}